import { BusinessReferenceType } from './BusinessReferenceType';

export const BusinessReferenceTypeOptions = [
    {
        id: BusinessReferenceType.Banking,
        text: 'Banking',
        requiredAmount: 1,
    },
    {
        id: BusinessReferenceType.PrimarySupplier,
        text: 'Primary Supplier',
        requiredAmount: 1,
    },
    {
        id: BusinessReferenceType.Trade,
        text: 'Trade',
        requiredAmount: 2,
    },
];
